<div class="row title">
	<h3>Dashboard / <span>Apartments Data</span></h3>
	<p class="add"  data-toggle="modal" data-target="#exampleModalLong" ><i class="fa fa-plus" aria-hidden="true"></i></p>

</div>
<div class="row">
	<div class="col-12" style="margin-top: 4rem;" *ngIf="msgError">
	  <div class="alert-box grid-100" *ngIf="errorMessage">
		<div class="alert alert-danger mt-3 text-center">
		<a class="close link" data-dismiss="alert">×</a>
		{{errorMessage}}
		</div>
	  </div>
	</div>
	<div class="col-12" style="margin-top: 4rem;" *ngIf="successError">
	   <div class="alert-box grid-100" *ngIf="successMessage">
		 <div class="alert alert-success mt-3 text-center">
		 <a class="close link" data-dismiss="alert">×</a>
		 {{successMessage}}
		 </div>
	   </div>
	 </div>
  </div>
<div class="row body_height justify-content-center">
   <div class="col-12 table-responsive p-0" id="scrollTop">
      <table class="table table-hover">
         <thead>
				<tr>
					<th class="text-center">S No</th>
					<th class="text-center">Name</th>
					<th class="text-center">City</th>
					<th class="text-center">UNID</th>
				
					<th class="table_img_col text-center">Image</th>
					<th class="table_active_col text-center">Actions</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let data of apartments |  paginate: { itemsPerPage: 10, currentPage:current_page }; let i=index" >
					<td>{{current_page*10+i+1-10}}</td> 
					<td class="text-center">{{data.attributes.apartment_name |  titlecase}}</td>
					<td class="text-center">{{data.attributes.city | titlecase}}</td>
					<td class="text-center">
						{{data.attributes.unid}}
					</td>
					
					<td class="text-center"> <img class="my-2" src="{{data.attributes.primary_image}}" onerror="src='../../../assets/img/default-apartment.png'" width="200px" *ngIf="data.attachment_file !='/images/original/missing.png' "><img src="../../../../assets/v3/img/noimgicon.jpeg" height="240px" width="260px" *ngIf="data.attachment_file =='/images/original/missing.png' "> </td>
					<td class="text-center fa_icons"> <a data-toggle="modal" data-target="#exampleModalLong2" (click)="getapartment(data.attributes.unid)"><i data-toggle="tooltip" title="Edit" data-placement="top" class="fa fa-pencil" aria-hidden="true"></i></a> <a (click)="confirmAndDelete(data.attributes.unid)"><i data-toggle="tooltip" title="Delete" data-placement="top" class="fa fa-trash" aria-hidden="true"></i></a>
						<div class="alert alert-warning my-2" *ngIf="(data.attributes.primary_image/1024) > 120"> <strong>Warning!</strong> Image size exceeds 120kb. </div>
						<!-- <div class="alert alert-danger my-2"  *ngIf="((data.attachment_height != null) || (data.attachment_width != null)) && ((data.attachment_height != 583) || (data.attachment_width != 1010))">
              <strong>Error!</strong> Image rcurrent_pageesolution doesn't match with the specified resolutions (1010 X 583).
            </div> -->
					</td>
				</tr>
			</tbody>
      </table>
      
   </div>
   <pagination-controls  autoHide="true" (pageChange)="current_page = $event" class="float-right"></pagination-controls>
</div>
<div  class="row justify-content-center internalPageBodyContent">
	<div class="col-md-10 col-md-offset-2 mb-3">
	   <!-- <button class="button button_emi" (click) = "back()"> BACK TO Apartment DATA</button> -->
	   <!-- <div class="alert alert-success text-center mt-2" *ngIf="successMessage">{{successMessage}}</div>
		  <div class="alert alert-danger text-center mt-2" *ngIf="errorMessage">{{errorMessage}}</div> -->
		  <div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
				   <form [formGroup]="createApartmentForm" (ngSubmit)="onSubmit(createApartmentForm.value); createApartmentForm.reset();" class="form-horizontal">
				   <!-- <fieldset formArrayName="apa"> -->
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Add Apartment Details</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
					</div>
				   <div class="row">
					  <!--For Apartment Name-->   
					  <div class="col-md-6">
						 <div class="form-group label-floating" >
							<label class="control-label">Apartment Name<span class="astric">*</span></label>
							<input type="text" min=0 class="form-control" placeholder="Enter Apartment Name"  formControlName="apartment_name">
						 </div>
					  </div>
					  <!--For Cluster-->   
					  <div class="col-md-6">
						 <div class="form-group label-floating" >
							<label class="control-label">Cluster</label>
							<input type="text" min=0 class="form-control" placeholder="Enter Cluster"  formControlName="cluster">
						 </div>
					  </div>
					  <!--For Apartment Address-->   
					  <div class="col-md-12">
						 <div class="form-group label-floating" >
							<label class="control-label">Apartment Addess<span class="astric">*</span></label>
							<input type="text" min=0 class="form-control" placeholder="Enter Apartment Addess"  formControlName="apartment_address">
						 </div>
					  </div>
					  <!-- For Pin Code-->  
					  <div class="col-md-6">
						 <div class="form-group label-floating" >
							<label class="control-label">Pin Code<span class="astric">*</span></label>
							<input type="number" min=0 class="form-control" placeholder="Enter Pin Code"  formControlName="pincode" onKeyPress="if(this.value.length==6) return false;" pattern="[0-9]{6}">
						 </div>
					  </div>
					  <!--Select City-->
					  <div class="col-md-6">
						 <div class="form-group label-floating">
							<label class="control-label">Search For State<span class="astric">*</span></label>
							<ng-select
							placeholder="Search For State"
							class=""
							formControlName="state"
							(change)="getscityList($event)">
							<ng-option *ngFor="let state of states" [value]="state.state_code">{{
							state.name | titlecase
							}}</ng-option>
							</ng-select>
						 </div>
					  </div>
					  <!--Select City-->
					  <div class="col-md-6">
						 <div class="form-group label-floating">
							<label class="control-label">Search For City<span class="astric">*</span></label>
							<ng-select
							   placeholder="Search For City"
							   class=""
							   formControlName="city">
							   <ng-option *ngFor="let city of city_list" [value]="city">{{
							   city | titlecase
							   }}</ng-option>
							</ng-select>
						 </div>
					  </div>
					  <!--UNID-->
					  <div class="col-md-6">
						 <div class="form-group label-floating" >
							<label class="control-label">UNID<span class="astric">*</span></label>
							<input type="text" min=0 class="form-control" placeholder="Enter UNID"   formControlName="unid" onKeyPress="if(this.value.length==15) return false;" [ngStyle]="{'border':createApartmentForm.get('unid').hasError('required') && createApartmentForm.get('unid').touched ? '1px solid red' : '1px solid #c7c7c7'}">
						 </div>
					  </div>
					  <p class="font-color bottom-note mb-0 notValid pl-2"
			   *ngIf="createApartmentForm.get('unid').touched && createApartmentForm.controls['unid'].value.length !== 15">
			   Please enter Min 15 Characters
			 </p>
					  <!--Area Name-->
					  <div class="col-md-6">
						 <div class="form-group label-floating" >
							<label class="control-label">Area Name<span class="astric">*</span></label>
							<input type="text" min=0 class="form-control" placeholder="Enter Area"  formControlName="area_name">
						 </div>
					  </div>
					  <!--Select Lifestage-->
					  <div class="col-md-6">
						 <div class="form-group label-floating" >
							<label class="control-label">Lifestage<span class="astric">*</span></label>
							<select class="form-control text-capitalize" formControlName="lifestage">
							   <option value="" selected>Select Lifestage</option>
							   <option class="text-capitalize" *ngFor="let v of lifeStage" value="{{v}}">{{v}}</option>
							</select>
						 </div>
					  </div>
					  <!--Select Theme-->
					  <div class="col-md-6">
						 <div class="form-group label-floating" >
							<label class="control-label">Theme<span class="astric">*</span></label>
							<select class="form-control text-capitalize" formControlName="theme">
							   <option value="" selected>Select Theme</option>
							   <option class="text-capitalize" *ngFor="let v of theme" value="{{v}}">{{v}}</option>
							</select>
						 </div>
					  </div>
					  <!--Developer Name-->
					  <div class="col-md-6">
						 <div class="form-group label-floating" >
							<label class="control-label">Developer Name<span class="astric">*</span></label>
							<input type="text" min=0 class="form-control" placeholder="Enter Developer Name"  formControlName="developer_name">
						 </div>
					  </div>
					  <div class="col-md-4">
						 <div class="form-group label-floating">
							<label class="control-label">Start From<span class="astric">*</span></label>
							<input type="number" min=0 class="form-control" placeholder="Enter Start From" formControlName="start_from">
						 </div>
					  </div>
					  <div class="col-md-4">
						 <div class="form-group label-floating">
							<label class="control-label">Apartment Value<span class="astric">*</span></label>
							<input type="number" min=0 class="form-control" placeholder="Enter Apartment Value" formControlName="apartment_value">
						 </div>
					  </div>
					  <div class="col-md-4">
						 <div class="form-group label-floating">
							<label class="control-label">Apartment Area<span class="astric">*</span></label>
							<input type="number" min=0 class="form-control" placeholder="Enter Apartment Area" formControlName="area">
						 </div>
					  </div>
 
 
					  <div class="col-md-4">
						 <div class="form-group label-floating">
							<label class="control-label">BOQ EMI<span class="astric">*</span></label>
							<input type="number" min=0 class="form-control" placeholder="Enter Emi" formControlName="boq_emi">
						 </div>
					  </div>
					 
					  <!--Format with varient id and layout image-->
					  <div class="col-md-12">
						 <fieldset formArrayName="formats"
							>
							<div class="row mt-3" *ngFor="let item of createApartmentForm.get('formats')['controls']; let i = index;" [formGroup]="item">
							<div class="card ml-3" style="width: 59rem !important;">
							   <div class="container-fluid">
								  <!--Select Format-->      
								  <div class="col-md-4 mt-3">
									 <div class="form-group label-floating" >
										<label class="control-label">Select Format<span class="astric">*</span></label>
										<select class="form-control text-capitalize" formControlName="name">
										   <option value="" selected>Select Format</option>
										   <option class="text-capitalize" *ngFor="let v of formatData" value="{{v}}">{{v}}</option>
										</select>
									 </div>
								  </div>
								  <!--Select Format Ends Here-->
								  <!--Variant Data Format-->
								  <div class="col-md-12">
									 <div class="card mb-3" style="width: 55rem !important;">
										<div class="container-fluid">
										   <fieldset formArrayName="variants">
											  <div class="row" *ngFor="let player of item.get('variants')['controls']; let j = index;" [formGroup]="player">
											  <div class="col-md-4">
												 <div class="form-group label-floating" >
													<label class="control-label">Variant ID<span class="astric">*</span></label>
													<input type="text" min=0 class="form-control" placeholder="Enter Variant ID"  formControlName="variant_id" onKeyPress="if(this.value.length==6) return false;">
												 </div>
											  </div>
											  <div class="col-md-4">
												 <div class="form-group label-floating">
													<label class="control-label">Select Layout Floor Plan<span class="astric">*</span></label>
													<input type="file" (change)="onChange($event,i,j)" class="form-control border-0" name="attachment_file" formControlName="layout_image">
												 </div>
											  </div>
											  <div class="col-md-4">
												 <div class="form-group label-floating">
													<label class="control-label">Select Primary Image<span class="astric">*</span></label>
													<input type="file" (change)="onChangeImage($event,i,j)" class="form-control border-0" name="attachment_file" formControlName="primary_image">
												 </div>
											  </div>
											  <div class="col-md-4">
												 <div class="form-group label-floating" >
													<label class="control-label">VR Link</label>
													<input type="text" min=0 class="form-control" placeholder="Enter VR Link"  formControlName="vr_link" >
												 </div>
											  </div>
											  
											  <div class="col-sm-12">
												 <a class="removeIcon" (click)="item.get('variants').removeAt(j)" *ngIf="item.get('variants').length > 1"><i class="fa fa-minus-circle mr-1" aria-hidden="true">Remove Last Variant</i></a>
											 </div>
										</div>
										<!-- <div class="col-sm-12">
										   <a class="removeIcon" (click)="item.get('variants').removeAt(j)"><i class="fa fa-minus-circle mr-1" aria-hidden="true">Remove Last Variant</i></a>
									   </div> -->
										</fieldset>
									 </div>
								  </div>
							   </div>
							  
							   <!--Variant Data Format Ends Here-->
							   <!-- <div class="col-sm-12">
								  <i class="fa fa-minus-circle remove_button" (click)="item.get('variants').removeAt(j)"></i>
							  </div> -->
							   <a (click)="addAnotherVariant(item)" class="addIcon"><i class="fa fa-plus mr-1" aria-hidden="true"></i>Add Another Variant</a>
							</div>
					  </div>
					  <div class="col-sm-12">
						 <a class="removeIcon" *ngIf="createApartmentForm.get('formats').length > 1" (click)="createApartmentForm.get('format').removeAt(i)"><i class="fa fa-minus-circle mr-1" aria-hidden="true"></i>Remove Last Format</a>
					 </div>
				   </div>
				   <!-- <div class="col-sm-12">
					  <a class="removeIcon" (click)="createApartmentForm.get('format').removeAt(i)"><i class="fa fa-minus-circle mr-1" aria-hidden="true"></i>Remove Last Format</a>
				  </div> -->
				   </fieldset>
				</div>
				<!--Format with varient id and layout image ends here-->
				<a (click)="pushJobAttributes(createApartmentForm)" class="addIcon ml-4 mt-3"><i class="fa fa-plus mr-1" aria-hidden="true"></i>Add Another Format</a>
			 </div>
			
			 <button type="submit"  [disabled]="!createApartmentForm.valid"  class="button pull-right" >Submit</button>  
			 </form>
		  </div>
	   </div>
	</div>
	<!-- ***************************************************************
	****************************************************************
	****************************************************************** -->
	<div class="modal fade" id="exampleModalLong2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
			   <form [formGroup]="updateApartmentForm" (ngSubmit)="onSubmit2(updateApartmentForm.value); updateApartmentForm.reset();" class="form-horizontal">
			   <!-- <fieldset formArrayName="apa"> -->
				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLongTitle">Update Apartment Details</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
				</div>
			   <div class="row">
				  <!--For Apartment Name-->   
				  <div class="col-md-6">
					 <div class="form-group label-floating" >
						<label class="control-label">Apartment Name<span class="astric">*</span></label>
						<input type="text" min=0 class="form-control" placeholder="Enter Apartment Name"  formControlName="apartment_name">
					 </div>
				  </div>
				  <!--For Cluster-->   
				  <div class="col-md-6">
					 <div class="form-group label-floating" >
						<label class="control-label">Cluster</label>
						<input type="text" min=0 class="form-control" placeholder="Enter Cluster" [(ngModel)]="Cluster"  formControlName="cluster">
					 </div>
				  </div>
				  <!--For Apartment Address-->   
				  <div class="col-md-12">
					 <div class="form-group label-floating" >
						<label class="control-label">Apartment Addess<span class="astric">*</span></label>
						<input type="text" min=0 class="form-control" placeholder="Enter Apartment Addess" [(ngModel)]="ApartmentAddess" formControlName="apartment_address">
					 </div>
				  </div>
				  <!-- For Pin Code-->  
				  <div class="col-md-6">
					 <div class="form-group label-floating" >
						<label class="control-label">Pin Code<span class="astric">*</span></label>
						<input type="number" min=0 class="form-control" [(ngModel)]="PinCode" placeholder="Enter Pin Code"  formControlName="pincode" onKeyPress="if(this.value.length==6) return false;" pattern="[0-9]{6}">
					 </div>
				  </div>
				  <!--Select City-->
				  <div class="col-md-6">
					 <div class="form-group label-floating">
						<label class="control-label">Search For State<span class="astric">*</span></label>
						<ng-select
						placeholder="Search For State"
						class=""
						formControlName="state"
						[(ngModel)]="SearchForState"
						(change)="getscityList($event)">
						<ng-option *ngFor="let state of states" [value]="state.state_code">{{
						state.name | titlecase
						}}</ng-option>
						</ng-select>
					 </div>
				  </div>
				  <!--Select City-->
				  <div class="col-md-6">
					 <div class="form-group label-floating">
						<label class="control-label">Search For City<span class="astric">*</span></label>
						<ng-select
						   placeholder="Search For City"
						   class=""
						   [(ngModel)]="SearchForCity"
						   formControlName="city">
						  
						   <ng-option *ngFor="let city of city_list" [value]="city">{{
						   city | titlecase
						   }}</ng-option>
						</ng-select>
					 </div>
				  </div>
				  <!--UNID-->
				  <div class="col-md-6">
					 <div class="form-group label-floating" >
						<label class="control-label">UNID<span class="astric">*</span></label>
						<input type="text" min=0 class="form-control" disabled placeholder="Enter UNID" [(ngModel)]="UNID"  formControlName="unid">
					 </div>
				  </div>
				 
				  <!--Area Name-->
				  <div class="col-md-6">
					 <div class="form-group label-floating" >
						<label class="control-label">Area Name<span class="astric">*</span></label>
						<input type="text" min=0 class="form-control" [(ngModel)]="AreaName" placeholder="Enter Area"  formControlName="area_name">
					 </div>
				  </div>
				  <!--Select Lifestage-->
				  <div class="col-md-6">
					 <div class="form-group label-floating" >
						<label class="control-label">Lifestage<span class="astric">*</span></label>
						<select class="form-control text-capitalize" name="lifestage"  [(ngModel)]="Lifestage" formControlName="lifestage"  >
						   <option value="" selected>Select Lifestage</option>
						   <option class="text-capitalize" *ngFor="let v of lifeStage"  [ngValue]="v">{{transform(v)}}</option>
						</select>
					 </div>
				  </div>
				  <!--Select Theme-->
				  <div class="col-md-6">
					 <div class="form-group label-floating" >
						<label class="control-label">Theme<span class="astric">*</span></label>
						<select class="form-control text-capitalize" [(ngModel)]="Theme" formControlName="theme">
						   <option value="" selected>Select Theme</option>
						   <option class="text-capitalize" *ngFor="let v of theme" value="{{v}}" >{{v}}</option>
						</select>
					 </div>
				  </div>
				  <!--Developer Name-->
				  <div class="col-md-6">
					 <div class="form-group label-floating" >
						<label class="control-label">Developer Name<span class="astric">*</span></label>
						<input type="text" min=0 class="form-control" [(ngModel)]="DeveloperName" placeholder="Enter Developer Name"  formControlName="developer_name">
					 </div>
				  </div>
				  <div class="col-md-4">
					 <div class="form-group label-floating">
						<label class="control-label">Start From<span class="astric">*</span></label>
						<input type="number" min=0 class="form-control" [(ngModel)]="StartFrom" placeholder="Enter Start From" formControlName="start_from">
					 </div>
				  </div>
				  <div class="col-md-4">
					 <div class="form-group label-floating">
						<label class="control-label">Apartment Value<span class="astric">*</span></label>
						<input type="number" min=0 class="form-control" [(ngModel)]="ApartmentValue" placeholder="Enter Apartment Value" formControlName="apartment_value">
					 </div>
				  </div>
				  <div class="col-md-4">
					 <div class="form-group label-floating">
						<label class="control-label">Apartment Area<span class="astric">*</span></label>
						<input type="number" min=0 class="form-control" [(ngModel)]="ApartmentArea" placeholder="Enter Apartment Area" formControlName="area">
					 </div>
				  </div>


				  <div class="col-md-4">
					 <div class="form-group label-floating">
						<label class="control-label">BOQ EMI<span class="astric">*</span></label>
						<input type="number" min=0 class="form-control" [(ngModel)]="BOQEMI" placeholder="Enter Emi" formControlName="boq_emi">
					 </div>
				  </div>
				 
				  <!--Format with varient id and layout image-->
				  <div class="col-md-12">
					<fieldset formArrayName="formats"
					   >
					   <div *ngFor="let format of dynamicformats; let i = index;" class="row mt-3">
                    



					   <div  *ngFor="let item of updateApartmentForm.get('formats')['controls']; let i = index;" [formGroup]="item" class="card ml-3" style="width: 59rem !important;">
						  <div class="container-fluid">
							 <!--Select Format-->      
							 <div  class="col-md-4 mt-3">
								<div class="form-group label-floating" >
								   <label class="control-label">Select Format<span class="astric">*</span></label>
								   <select class="form-control text-capitalize" [(ngModel)]="format[0].format_name"  [value]="format[0].format_name" formControlName="name">
									  <option value="" selected>Select Format</option>
									  <option class="text-capitalize" *ngFor="let v of formatData" value="{{v}}">{{v}}</option>
								   </select>
								</div>
							 </div>
							 <!--Select Format Ends Here-->
							 <!--Variant Data Format-->
							 <div *ngFor="let varient of format" class="col-md-12">
								<div  class="card mb-3" style="width: 55rem !important;">
								   <div class="container-fluid">
									  <fieldset formArrayName="variants">
										 <div class="row" *ngFor="let player of item.get('variants')['controls']; let j = index;" [formGroup]="player">
										 <div class="col-md-4">
											<div class="form-group label-floating" >
											   <label class="control-label">Variant ID<span class="astric">*</span></label>
											   <input type="text" min=0 class="form-control"  placeholder="Enter Variant ID"   [value]="varient.variant_id"  formControlName="variant_id" onKeyPress="if(this.value.length==6) return false;">
											</div>
										 </div>
										 <div class="col-md-4">
											<div class="form-group label-floating">
											   <label class="control-label">Select Layout Floor Plan<span class="astric">*</span></label>
											   <input type="file" (change)="onChange($event,i,j)" class="form-control border-0"  name="attachment_file" formControlName="layout_image">
											   <img src ="{{varient.layout_image}}" onerror="src='../../../assets/img/default-apartment.png'" height="300px" width="300px">
											</div>
											   										 										 </div>
										 <div class="col-md-4">
											<div class="form-group label-floating">
											   <label class="control-label">Select Primary Image<span class="astric">*</span></label>
											   <input type="file" (change)="onChangeImage($event,i,j)" class="form-control border-0"   name="attachment_file" formControlName="primary_image">
											   <img src ="{{varient.primary_image}}" onerror="src='../../../assets/img/default-apartment.png'"  height="300px" width="300px">
											</div>
										 </div>
										 <div class="col-md-4">
											<div class="form-group label-floating" >
											   <label class="control-label">VR Link</label>
											   <input type="text" min=0 class="form-control" placeholder="Enter VR Link" [(ngModel)]="varient.vr_link"  formControlName="vr_link" >
											</div>
										 </div>
										 
										 <div class="col-sm-12">
											<a class="removeIcon" (click)="item.get('variants').removeAt(j)" *ngIf="item.get('variants').length > 1"><i class="fa fa-minus-circle mr-1" aria-hidden="true">Remove Last Variant</i></a>
										</div>
								   </div>
								   <!-- <div class="col-sm-12">
									  <a class="removeIcon" (click)="item.get('variants').removeAt(j)"><i class="fa fa-minus-circle mr-1" aria-hidden="true">Remove Last Variant</i></a>
								  </div> -->
								   </fieldset>
								</div>
							 </div>
						  </div>
						 
						  <!--Variant Data Format Ends Here-->
						  <!-- <div class="col-sm-12">
							 <i class="fa fa-minus-circle remove_button" (click)="item.get('variants').removeAt(j)"></i>
						 </div> -->
						  <a (click)="addAnotherVariantup(item)" class="addIcon"><i class="fa fa-plus mr-1" aria-hidden="true"></i>Add Another Variant</a>
					   </div>
				 </div>
				 <div class="col-sm-12">
					<a class="removeIcon" *ngIf="updateApartmentForm.get('formats').length > 1" (click)="updateApartmentForm.get('format').removeAt(i)"><i class="fa fa-minus-circle mr-1" aria-hidden="true"></i>Remove Last Format</a>
				</div>
			  </div>
			  <!-- <div class="col-sm-12">
				 <a class="removeIcon" (click)="createApartmentForm.get('format').removeAt(i)"><i class="fa fa-minus-circle mr-1" aria-hidden="true"></i>Remove Last Format</a>
			 </div> -->
			  </fieldset>
		   </div>
		   <!--Format with varient id and layout image ends here-->
		   <a (click)="pushJobAttributesup(updateApartmentForm)" class="addIcon ml-4 mt-3"><i class="fa fa-plus mr-1" aria-hidden="true"></i>Add Another Format</a>
		
            

		
		 </div>
		 
		
		 <button type="submit" class="button pull-right"  >Update</button>  
		 </form>
	  </div>
   </div>
</div>
 </div>
 </div>
 




// WEBPACK FOOTER //
// ./src/app/platform/organisation/add-apartment/add-apartment.component.html